<template>
  <h4 class="alert alert-danger">
    {{ $t("HALL_IS_NOT_LOADED_WITH_RAW_PRODUCTS_AND_MATERIALS") }}
    {{ routemap.materialDate | formatDateTime }} {{ $t("YEAR_ABBR") }}
  </h4>
</template>

<script>
export default {
  props: {
    routemap: {
      required: true,
      type: Object
    }
  }
};
</script>
